import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (hideHeader) => {
  if (hideHeader) {
    return {
      borderRadius: 0,
      border: 'none',
    };
  }
  return {};
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.5),
  '& > div:first-of-type': {
    flexShrink: 0,
  },
  '& > div:last-of-type': {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    justifyContent: 'flex-end',
  },
};
